import { type ErrorBoundaryProps, ErrorState } from '@/screens/workspace/components'
import { useT } from '~/core/i18n'

export default function TablesError({ error, reset }: ErrorBoundaryProps) {
  const t = useT()
  return (
    <ErrorState
      error={error}
      reset={reset}
      title={t('Failed to load tables')}
      description={t('Something went wrong while loading the tables. Please try again.')}
      loggerName='TablesError'
    />
  )
}
